import { create } from "zustand";
import { SessionStatus } from "../types/appStream";

interface SessionDataStore {
  sessionStatus: SessionStatus;
  sessionID: string | undefined;
  copiedTextFromRemote: string | undefined;
  sessionStartTime: number | undefined;
  microphoneEnabledDuration: number;
  microphoneLastEnabledTime: number | undefined;
  setSessionStatus: (value: SessionStatus) => void;
  setSessionID: (value: string | undefined) => void;
  setCopiedTextFromRemote: (value: string | undefined) => void;
  setSessionStartTime: (timestamp: number | undefined) => void;
  addMicrophoneEnabledDuration: (duration: number) => void;
  setMicrophoneLastEnabledTime: (timestamp: number | undefined) => void;
}

/**
 * Store for data from remote session
 */
export const useSessionDataStore = create<SessionDataStore>((set) => ({
  sessionStatus: "Unknown",
  copiedTextFromRemote: undefined,
  sessionID: undefined,
  sessionStartTime: undefined,
  microphoneEnabledDuration: 0,
  microphoneLastEnabledTime: undefined,
  setSessionStatus: (value) =>
    set((state) => ({
      ...state,
      sessionStatus: value,
    })),
  setSessionID: (value) =>
    set((state) => ({
      ...state,
      sessionID: value,
    })),
  setCopiedTextFromRemote: (value) =>
    set((state) => ({
      ...state,
      copiedTextFromRemote: value,
    })),
  setSessionStartTime: (timestamp: number) =>
    set((state) => ({
      ...state,
      sessionStartTime: timestamp,
    })),
  addMicrophoneEnabledDuration: (duration: number) =>
    set((state) => ({
      ...state,
      microphoneEnabledDuration: state.microphoneEnabledDuration + duration,
    })),
  setMicrophoneLastEnabledTime: (timestamp: number) =>
    set((state) => ({
      ...state,
      microphoneLastEnabledTime: timestamp,
    })),
}));
